import { GuestbookClient } from '../GuestbookClient'
import { GuestbookEvent } from '@/shared/types'
import { uploadImage } from './uploadImage'
import { deleteImage } from './deleteImage'
import { getEndpoint } from '@/ui/core/config'
import { ensureDefined } from '@/utils'

export interface UpdateWelcomeInput {
  eventId: string
  welcomeHeader?: string
  welcomeMessage?: string
  welcomeImage?: File
  imagesToDelete?: string[]
}

export async function updateWelcome(
  this: GuestbookClient,
  input: UpdateWelcomeInput,
) {
  const jwtToken = await this.auth.getJWT()
  if (!jwtToken) {
    throw new Error('Missing token')
  }
  const owner = await this.auth.getUser()

  const { welcomeImage, imagesToDelete, eventId, ...props } = input

  const event: Partial<GuestbookEvent> = {
    id: eventId,
    ...props,
  }

  let imageUrl: string[] | undefined
  if (welcomeImage) {
    imageUrl = [
      await uploadImage({
        file: welcomeImage,
        location: 'events',
        keyPrefix: owner,
        jwtToken,
      }),
    ]
  }

  if (imagesToDelete && imagesToDelete.length > 0) {
    for (const image of imagesToDelete) {
      await deleteImage({
        url: image,
        location: 'events',
        jwtToken,
      })
    }
    imageUrl = []
  }

  if (imageUrl !== undefined) {
    event.images = imageUrl
  }

  await fetch(getEndpoint('events'), {
    method: 'PUT',
    body: JSON.stringify(event),
    headers: {
      Authorization: jwtToken,
    },
  })

  return ensureDefined(event.id)
}
